(function () {
  if (window.xjHomeSplashLoaded) return;
  window.xjHomeSplashLoaded = true;

  function initSplash(root) {
    if (!root) return;
    if (root.dataset.xjInitialized === 'true') return;

    root.dataset.xjInitialized = 'true';

    const mask = root.querySelector(
      '[data-xj-splash-mask]'
    );

    const container = root.querySelector(
      '[data-xj-splash-container]'
    );

    const logo = root.querySelector(
      '.xj-home-splash__logo'
    );

    if (!mask || !container || !logo) {
      root.remove();
      return;
    }

    const CONFIG = {
      delayBeforeUnlock:
        Number(root.dataset.delayBeforeUnlock) || 1200,

      animationRange:
        Number(root.dataset.animationRange) || 350,

      completionThreshold: 0.995,

      replayAfterMs:
        (Number(root.dataset.replayHours) || 24)
        * 60
        * 60
        * 1000,

      storageKey: 'xj_splash_last_seen'
    };

    function removeSplash() {
      document.body.classList.remove(
        'xj-home-splash-locked'
      );

      if (root.parentNode) {
        root.remove();
      }
    }

    let forceReplay = false;

    try {
      forceReplay =
        new URLSearchParams(
          window.location.search
        ).get('splash') === '1';
    } catch (error) {}

    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      removeSplash();
      return;
    }

    if (!forceReplay) {
      try {
        const lastSeen = parseInt(
          localStorage.getItem(
            CONFIG.storageKey
          ) || '0',
          10
        );

        if (
          Date.now() - lastSeen <
          CONFIG.replayAfterMs
        ) {
          removeSplash();
          return;
        }
      } catch (error) {}
    }

    const header =
      document.querySelector('[data-theme-header]');

    if (!header) {
      removeSplash();
      return;
    }

    function findHeaderLogoLinks() {
      const headings =
        header.querySelectorAll('h1.contents');

      const links = [];

      headings.forEach((heading) => {
        const link = heading.closest('a');

        if (
          link &&
          !links.includes(link)
        ) {
          links.push(link);
        }
      });

      return links;
    }

    function getVisibleLogo(links) {
      for (
        let index = 0;
        index < links.length;
        index++
      ) {
        if (
          links[index].offsetWidth > 0 &&
          links[index].offsetHeight > 0
        ) {
          return links[index];
        }
      }

      return links[0] || null;
    }

    const headerLogos =
      findHeaderLogoLinks();

    /*
     * Important fail-safe:
     * If a future Baseline update changes
     * its logo markup, don't break the page.
     * Just skip the splash.
     */
    if (!headerLogos.length) {
      console.warn(
        'XJ Home Splash: header logo target not found.'
      );

      removeSplash();
      return;
    }

    /*
     * Only force scroll-to-top when
     * the splash is actually going to play.
     */
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);

    try {
      localStorage.setItem(
        CONFIG.storageKey,
        String(Date.now())
      );
    } catch (error) {}

    headerLogos.forEach((element) => {
      element.style.transition =
        'opacity 0.3s ease';

      element.style.opacity = '0';
    });

    const state = {
      scrollY: 0,
      ticking: false,
      isComplete: false,

      params: {
        translateX: 0,
        translateY: 0,
        scale: 1
      }
    };

    document.body.classList.add(
      'xj-home-splash-locked'
    );

    function showLogo() {
      logo.classList.add('is-loaded');
    }

    if (logo.complete) {
      requestAnimationFrame(showLogo);
    } else {
      logo.addEventListener(
        'load',
        showLogo,
        { once: true }
      );
    }

    setTimeout(() => {
      mask.style.opacity = '0';

      document.body.classList.remove(
        'xj-home-splash-locked'
      );

      mask.addEventListener(
        'transitionend',
        function () {
          mask.classList.add(
            'is-complete'
          );
        },
        { once: true }
      );
    }, CONFIG.delayBeforeUnlock);

    function calculateParams() {
      const visible =
        getVisibleLogo(headerLogos);

      const heroWidth =
        logo.offsetWidth;

      if (!heroWidth) return;

      let targetCenterX;
      let targetCenterY;
      let targetWidth;

      if (visible) {
        const inner =
          visible.querySelector('div') ||
          visible;

        const rect =
          inner.getBoundingClientRect();

        targetCenterX =
          rect.left +
          rect.width / 2;

        targetCenterY =
          rect.top +
          rect.height / 2;

        targetWidth =
          rect.width;
      } else {
        return;
      }

      const heroCenterX =
        window.innerWidth / 2;

      const heroCenterY =
        window.innerHeight / 2;

      state.params.translateX =
        targetCenterX - heroCenterX;

      state.params.translateY =
        targetCenterY - heroCenterY;

      state.params.scale =
        targetWidth / heroWidth;
    }

    function easeInOutCubic(value) {
      return value < 0.5
        ? 4 * value * value * value
        : 1 -
            Math.pow(
              -2 * value + 2,
              3
            ) / 2;
    }

    function handOff() {
      if (state.isComplete) return;

      state.isComplete = true;

      headerLogos.forEach((element) => {
        element.style.opacity = '1';
      });

      requestAnimationFrame(() => {
        container.classList.add(
          'is-complete'
        );

        mask.classList.add(
          'is-complete'
        );
      });

      /*
       * Give the fade a moment,
       * then return control completely
       * to Baseline.
       */
      setTimeout(() => {
        headerLogos.forEach((element) => {
          element.style.removeProperty(
            'opacity'
          );

          element.style.removeProperty(
            'transition'
          );
        });
      }, 350);
    }

    function update() {
      if (state.isComplete) return;

      const progress =
        Math.min(
          state.scrollY /
            CONFIG.animationRange,
          1
        );

      if (
        progress >=
        CONFIG.completionThreshold
      ) {
        handOff();
        return;
      }

      if (progress === 0) {
        container.style.transform = '';
        return;
      }

      const eased =
        easeInOutCubic(progress);

      const translateX =
        state.params.translateX *
        eased;

      const translateY =
        state.params.translateY *
        eased;

      const scale =
        1 +
        (
          state.params.scale - 1
        ) *
        eased;

      container.style.transform =
        `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (state.isComplete) return;

        state.scrollY =
          window.scrollY;

        if (!state.ticking) {
          requestAnimationFrame(() => {
            update();
            state.ticking = false;
          });

          state.ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        if (state.isComplete) return;

        calculateParams();
        update();
      }
    );

    if (logo.complete) {
      calculateParams();
    } else {
      logo.addEventListener(
        'load',
        calculateParams,
        { once: true }
      );
    }

    window.addEventListener(
      'load',
      calculateParams,
      { once: true }
    );
  }

  function initFrom(scope) {
    if (!scope) return;

    if (
      scope.matches &&
      scope.matches(
        '[data-xj-home-splash]'
      )
    ) {
      initSplash(scope);
      return;
    }

    const root =
      scope.querySelector &&
      scope.querySelector(
        '[data-xj-home-splash]'
      );

    if (root) {
      initSplash(root);
    }
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initFrom(document);
      }
    );
  } else {
    initFrom(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initFrom(event.target);
    }
  );
})();